import { useState, useCallback } from 'react';
import { SSHService } from '../service/sshService';

interface SshServerInfo {
  ip: string;
  user: string;
  password: string;
  // Optional: name for logging, if desired
  name?: string; 
}

export const useSshHandler = (): [
  boolean, // isCopied
  (serverInfo: SshServerInfo, componentName?: string) => Promise<void> // handleSshConnect function
] => {
  const [isCopied, setIsCopied] = useState<boolean>(false);

  const handleSshConnect = useCallback(
    async (serverInfo: SshServerInfo, componentName: string = 'component') => {
      if (!serverInfo || !serverInfo.ip || !serverInfo.user || !serverInfo.password) {
        console.error('SSH Handler: Server information is incomplete.', serverInfo);
        alert('Fehler: Unvollständige Serverinformationen für SSH.');
        return;
      }

      SSHService.openSSHTerminal(serverInfo.ip, serverInfo.user, serverInfo.password);

      try {
        await navigator.clipboard.writeText(serverInfo.password);
        setIsCopied(true);
        console.log(`SSH password for ${serverInfo.name || serverInfo.ip} copied to clipboard (from ${componentName})`);
        setTimeout(() => setIsCopied(false), 2500);
      } catch (error) {
        console.error(`Failed to copy SSH password to clipboard (from ${componentName}):`, error);
        alert('Passwort konnte nicht in die Zwischenablage kopiert werden.');
      }
    },
    []
  );

  return [isCopied, handleSshConnect];
}; 